import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Activity, MessageCircle, TrendingUp, UserPlus } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, BarChart, Bar } from "recharts";

const stats = [
  { key: "leads", label: "Total prospectos", Icon: UserPlus, color: "#00F0FF" },
  { key: "new_leads", label: "Nuevos sin contactar", Icon: TrendingUp, color: "#00FF66" },
  { key: "visits", label: "Visitas totales", Icon: Activity, color: "#A78BFA" },
  { key: "whatsapp_clicks", label: "Clics WhatsApp", Icon: MessageCircle, color: "#10B981" },
];

export default function Dashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setData(r.data)); }, []);
  if (!data) return <div className="label-mono text-cyan-300">CARGANDO...</div>;

  return (
    <div data-testid="admin-dashboard">
      <header className="mb-8">
        <div className="label-mono mb-1">/ Dashboard</div>
        <h1 className="font-display text-4xl chrome-text">Centro de control</h1>
      </header>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {stats.map((s) => (
          <div key={s.key} className="glass-card chrome-border p-5" data-testid={`stat-${s.key}`}>
            <div className="flex items-center justify-between">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: `${s.color}20`, border: `1px solid ${s.color}55` }}>
                <s.Icon className="w-5 h-5" style={{ color: s.color }} />
              </div>
              <span className="label-mono">↗</span>
            </div>
            <div className="mt-4 font-display text-3xl chrome-text">{data.totals[s.key] ?? 0}</div>
            <div className="label-mono mt-1">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 glass-card chrome-border p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-tech text-white">Actividad últimos 7 días</h3>
            <span className="label-mono">visits · leads · wa</span>
          </div>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data.daily}>
                <CartesianGrid stroke="#1f2937" strokeDasharray="3 3" />
                <XAxis dataKey="day" stroke="#6E7A94" fontSize={12} />
                <YAxis stroke="#6E7A94" fontSize={12} />
                <Tooltip contentStyle={{ background: "#0B0F17", border: "1px solid #2a3548", borderRadius: 8 }} />
                <Line type="monotone" dataKey="visits" stroke="#00F0FF" strokeWidth={2} dot={false} />
                <Line type="monotone" dataKey="leads" stroke="#00FF66" strokeWidth={2} dot={false} />
                <Line type="monotone" dataKey="whatsapp" stroke="#A78BFA" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="glass-card chrome-border p-6">
          <h3 className="font-tech text-white mb-4">Prospectos por estado</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={Object.entries(data.by_status).map(([k,v])=>({ name: k, value: v }))}>
                <CartesianGrid stroke="#1f2937" strokeDasharray="3 3" />
                <XAxis dataKey="name" stroke="#6E7A94" fontSize={11} />
                <YAxis stroke="#6E7A94" fontSize={11} />
                <Tooltip contentStyle={{ background: "#0B0F17", border: "1px solid #2a3548", borderRadius: 8 }} />
                <Bar dataKey="value" fill="#00F0FF" radius={[6,6,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="mt-5 glass-card chrome-border p-6">
        <h3 className="font-tech text-white mb-4">Prospectos recientes</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="label-mono text-left">
              <tr className="border-b border-white/5">
                <th className="py-3 pr-4">Nombre</th><th className="py-3 pr-4">Teléfono</th>
                <th className="py-3 pr-4">Empresa</th><th className="py-3 pr-4">Estado</th><th className="py-3 pr-4">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {data.recent_leads?.length ? data.recent_leads.map((l) => (
                <tr key={l.id} className="border-b border-white/5 text-white/80">
                  <td className="py-3 pr-4">{l.name}</td><td className="py-3 pr-4">{l.phone}</td>
                  <td className="py-3 pr-4">{l.company || "—"}</td>
                  <td className="py-3 pr-4"><span className="px-2 py-1 rounded-full text-xs border border-cyan-400/40 bg-cyan-400/10 text-cyan-300">{l.status}</span></td>
                  <td className="py-3 pr-4 label-mono">{new Date(l.created_at).toLocaleString()}</td>
                </tr>
              )) : <tr><td colSpan={5} className="py-6 text-center text-white/40">Sin prospectos aún</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
